import { QuestionMarkCircleIcon } from "@heroicons/react/solid"

interface TooltipCircleProps {
  text: string;
}
export const TooltipCircle = ({text}: TooltipCircleProps) => {
  return (
    <span
      data-tooltip-id="tooltip"
      data-tooltip-html={text}
      className="w-fit whitespace-pre-wrap"
    >
      <QuestionMarkCircleIcon className="w-4 h-4 outline-none inline-block align-top ml-0.5" />
    </span>
  )
}